// MkModal.js  
import React from 'react';
import { Modal, Button } from 'antd';
import './index.scss';

const MkModal = React.memo(({
  visible,
  onCancel,
  onOk,
  onBtn,
  cls,
  onBtnVisable,
  isGuide = false,
  title,
  content,
  okText = '确定',
  cancelText = '取消',
  maskClosable = false,
  cancelVisble = false,
  destroyOnClose = false,
  tongquStyle = false,
}) => {
  const modalCls = `wkModal ${tongquStyle ? 'wkModal--tongqu' : ''} ${cls || ''}`.trim();
  return (
    <Modal
      title={title}
      open={visible}
      onCancel={onCancel}
      cancelText={cancelText}
      centered={true}
      onOk={onOk}
      className={modalCls}
      closable={true}
      maskClosable={maskClosable}
      destroyOnClose={true}
      footer={[
        onBtnVisable ? <Button key="cancel" onClick={onBtn} className={isGuide ? 'guide' : ''}>
          {cancelText}
        </Button> : null,

        onOk ? <Button key="ok" type="primary" onClick={onOk}>
          {okText}
        </Button > : null,
      ]}
    >
      {content}
    </Modal >
  );
});

export default MkModal;